
import { defineComponent, type PropType } from "vue-demi";

export default defineComponent({
  name: "GGPromoButton",
  props: {
    /**
     * Текст кнопки
     */
    text: {
      type: String as PropType<string | null>,
      default: null,
    },
    /**
     * Цвет кнопки
     * Поддерживаемые значения: "transparent-white", "transparent-black", "black"
     */
    color: {
      type: String as PropType<string>,
      default: "black",
      validator(el) {
        return ["transparent-white", "transparent-black", "black"].some(
          (item) => item === el
        );
      },
    },
    copiedText: {
      type: String as PropType<string | null>,
      default: "Скопировано в буфер обмена",
    },
  },
  data(): {
    copied: boolean;
  } {
    return {
      copied: false,
    };
  },
  methods: {
    copyToClipboard() {
      if (this.text && typeof this.text === "string")
        navigator.clipboard.writeText(this.text).then(() => {
          this.copied = true;
          setTimeout(() => {
            this.copied = false;
          }, 1500);
        });
    },
  },
});
